import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import ThemeElevenTitle from '../components/ThemeElevenTitle';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import getIcons from '../../functions/getIcons/getIcons';
import { useTranslation } from 'react-i18next';

const ThemeElevenCompanyScreen = props => {
  const { t } = useTranslation('common');
  const operator = props.home.operator;
  return (
    <div className="themes-theme-eleven-company-screen">
      <KuposHelmet />

      <div style={{ position: 'relative', marginTop: '-41px' }}>
        <HeroSection heroImage={getIcons('companyBanner')} />
      </div>

      <ThemeElevenTitle
        operator={props.home.operator}
        smallHeading={t("EMPRESA.SMALL_HEADING")}
        boldHeading={t("EMPRESA.BOLD_HEADING")}
      />

      <div style={{ marginBottom: -40 }}>
        <img src={t("EMPRESA.IMG")} />
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeElevenCompanyScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/pages/ThemeElevenCompanyScreen.js